import { isDefined } from 'common';

/**
 * This file contains colors to decorate the template card and icon.
 */

enum SolutionArea {
  Access = 'Access',
  CareOperations = 'CareOperations',
  RevenueCycle = 'RevenueCycle',
  Other = 'Other',
}

interface GradientColors {
  dark: string;
  light: string;
}

const solutionAreaColors: Record<SolutionArea, GradientColors> = {
  [SolutionArea.Access]: {
    dark: '#8548DB',
    light: '#B989FD',
  },
  [SolutionArea.CareOperations]: {
    dark: '#AF268F',
    light: '#E176C8',
  },
  [SolutionArea.RevenueCycle]: {
    dark: '#0FAA81',
    light: '#2EDCAE',
  },
  [SolutionArea.Other]: {
    dark: '#2696AF',
    light: '#4EC3DD',
  },
};

const placeholderColors = {
  // gray gradient
  dark: '#d9d9d9',
  light: '#f7f7f7',
} satisfies GradientColors;

function isKnownSolutionArea(solutionArea: string): solutionArea is SolutionArea {
  return solutionArea in solutionAreaColors;
}

export function getFlowTemplateCardColors(args: { solutionArea?: string }) {
  const { solutionArea } = args;
  if (!isDefined(solutionArea) || !isKnownSolutionArea(solutionArea)) {
    return placeholderColors;
  }
  return solutionAreaColors[solutionArea] ?? placeholderColors;
}
